import {Button, Drawer} from 'antd';
import React, {Component} from 'react';
import API from "../../Utils/API";
import NotificationUtil from "../../Utils/NotificationUtil";
import {UserForm} from "./UserForm";

class UserDrawer extends Component {

    save = (e) => {
        const {form} = this.formRef.props;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }

            const data = {
                id: this.props.editId[0],
                fullName: values.fullName,
                username: values.username,
                password: values.password,
                tags: values.tags
            }

            API.post("/settings/saveUser", data)
                .then(res => {
                    form.resetFields();
                    this.props.onClose(e, true);
                    NotificationUtil(res.data);
                }).catch(error => {
                NotificationUtil({msg: "Hiba történt!" + error, type: "error"});
                this.props.onClose(e, true);
            });
        });
    };

    constructor(props) {
        super(props);
        this.state = {
            user: {fullName: ""},
            title: ""
        };
    }

    saveFormRef = formRef => {
        this.formRef = formRef;
    };

    open = () => {
        if (this.props.editId !== "") {
            API.get("/settings/getUser/" + this.props.editId).then(res => {
                this.setState({user: res.data});
                this.setState({title: "Felhasználó módosítása : " + res.data.fullName});
            });
        } else {
            this.setState({user: {fullName: ""}});
            this.setState({title: "Új felhasználó felvétele"});
        }
    };

    render() {
        return (
            <Drawer
                destroyOnClose={true}
                width={480}
                title={this.state.title}
                placement="right"
                closable={true}
                afterVisibleChange={this.open}
                onClose={this.props.onClose}
                visible={this.props.visible}
            >

                <UserForm {...this.state.user} wrappedComponentRef={this.saveFormRef}
                          initialName={this.state.user.fullName}/>

                <div
                    style={{
                        position: 'absolute',
                        left: 0,
                        bottom: 0,
                        width: '100%',
                        borderTop: '1px solid #e9e9e9',
                        padding: '10px 16px',
                        background: '#fff',
                        textAlign: 'right',
                    }}
                >
                    <Button onClick={this.props.onClose} style={{marginRight: 8}}>
                        Mégsem
                    </Button>
                    <Button onClick={this.save} type="primary">
                        Mentés
                    </Button>
                </div>
            </Drawer>
        );
    }
}

export default UserDrawer;

